import { createContext, useContext, useState } from "react";

const AppModeContext = createContext({
  mode: "admin", // 'admin' | 'user' | null
  currentUser: null, // { id, name } ou null
  setMode: () => {},
  selectUser: () => {},
  resetMode: () => {},
});

export function AppModeProvider({ children }) {
  const storedMode = localStorage.getItem("appMode");
  const storedUser = localStorage.getItem("currentUser");

  const [mode, setModeState] = useState(storedMode || null);
  const [currentUser, setCurrentUser] = useState(
    storedUser ? JSON.parse(storedUser) : null,
  );

  const setMode = (newMode) => {
    console.info("Mode", newMode);
    localStorage.setItem("appMode", newMode);
    setModeState(newMode);
  };

  const selectUser = (user) => {
    setCurrentUser(user);
    localStorage.setItem("currentUser", JSON.stringify(user));
    setMode("user"); // automatiquement passer en mode 'user'
  };

  const resetMode = () => {
    localStorage.removeItem("appMode");
    localStorage.removeItem("currentUser");
    setModeState(null);
    setCurrentUser(null);
  };

  return (
    <AppModeContext.Provider
      value={{ mode, currentUser, setMode, selectUser, resetMode }}
    >
      {children}
    </AppModeContext.Provider>
  );
}

export function useAppMode() {
  return useContext(AppModeContext);
}
